export const validateEmail = (inputText: string): boolean => {
  const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  if (inputText.match(mailFormat)) {
    return true;
  } else {
    return false;
  }
};

export const validateContactNumber = (inputText: string): boolean => {
  const phoneNo = /^\d{10}$/;
  if (inputText.match(phoneNo)) {
    return true;
  } else {
    return false;
  }
};

export const validDocNumber = (inputText: string): boolean => {
  if (!inputText) {
    return true;
  }
  const docNum = /^[a-z0-9]+$/i;
  if (inputText.match(docNum)) {
    return true;
  } else {
    return false;
  }
};

export const validPANNo = (inputText: string): boolean => {
  const pan = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
  if (inputText.match(pan)) {
    return true;
  } else {
    return false;
  }
};

export const validateAdharNo = (inputText: string): boolean => {
  const adharNo = /^[2-9]{1}[0-9]{3}\s{1}[0-9]{4}\s{1}[0-9]{4}$/;
  if (inputText.match(adharNo)) {
    return true;
  } else {
    return false;
  }
};
export const validvoterNo = (inputText: string): boolean => {
  const voter = /^([a-zA-Z]){3}([0-9]){7}?$/;
  if (inputText.match(voter)) {
    return true;
  } else {
    return false;
  }
};

export const validString = (inputText: string): boolean => {
  const string = /^[a-zA-Z]*$/;
  if (inputText.match(string)) {
    return true;
  } else {
    return false;
  }
};
export const validStringWithSpace = (inputText: string): boolean => {
  const string = /^[A-Za-z\s]*$/;
  if (inputText.match(string)) {
    return true;
  } else {
    return false;
  }
};

export const validVariable = (inputText: string): boolean => {
  const string = /^[a-zA-Z_$][a-zA-Z_$0-9]*$/;
  if (inputText.match(string)) {
    return true;
  } else {
    return false;
  }
};
// /^[a - zA-Z_$0-9]*$/

export const formateAdharNumber = (value: string) => {
  const updatedValue = value.replaceAll(" ", "");
  let newValue = "";
  for (let i = 0; i < updatedValue.length; i++) {
    if (i == 3 || i == 7) {
      newValue += updatedValue.charAt(i) + " ";
    } else {
      newValue += updatedValue.charAt(i);
    }
  }
  return newValue;
};

export const validDomain = (inputText: string): boolean => {
  const string = /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/;
  if (inputText.match(string)) {
    return true;
  } else {
    return false;
  }
};
